var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.noLink)?_c('router-link',{attrs:{"to":_vm.to}},[_c('img',{attrs:{"src":require("@/assets/img/propuesta-1-x2.svg"),"alt":"","width":_vm.lg ? '200px' : _vm.width}})]):_c('img',{attrs:{"src":require("@/assets/img/propuesta-1-x2.svg"),"alt":"","width":_vm.lg ? '200px' : _vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }